// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assing-agncy {
  height: 54px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
}
.assing-agncy .assing-agncy-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff url('agency-icon-blue.8eed463b0cbddad9.svg') no-repeat center center;
  background-size: 45%;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #C7C7C7;
  padding: 4px;
}

.gc-agency-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1F2937;
}

p.gc-agency-handle {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.gc-agency-img {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gc-agency-img img {
  min-width: 100%;
}

.icon-badge-gold:before {
  content: "\\e900";
  color: #f2c94c;
}

.gc-pr-12 {
  padding-right: 12px !important;
}

.gc-pl-12 {
  padding-left: 12px !important;
}

.custom-invalid {
  border: 1px solid red !important;
}

.validation-text {
  display: block;
  margin-top: 5px;
  color: red;
}

.max-img-note {
  font-size: 12px;
  margin: 8px 0 20px 0;
}

.table-header > div:first-child {
  flex: 1 1 0;
  min-width: min-content;
}
.table-header > div:first-child .user-label {
  min-width: max-content;
}
.table-header h2 {
  line-height: 1;
}
.table-header .table-search-wrapper {
  max-width: 452px;
  flex: 1 1 auto;
  margin: 0;
}
.table-header .table-calendar-wrapper,
.table-header .field,
.table-header .export-btn,
.table-header p-button {
  margin: 0;
}
.table-header .field {
  margin-bottom: 0 !important;
}
@media (max-width: 1200px) {
  .table-header {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .table-header .table-search-wrapper {
    max-width: 100%;
    width: 100%;
  }
}

::ng-deep .app-link-dropdown.p-dropdown {
  display: flex !important;
  align-items: center !important;
}
::ng-deep .app-link-dropdown.p-dropdown .p-dropdown-label {
  display: flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  line-height: normal !important;
  height: 100% !important;
}

.export-button {
  pointer-events: none;
}

.export-report {
  position: relative;
  display: inline-block;
}
.export-report .p-button {
  position: relative;
  z-index: 2;
  pointer-events: none;
}
.export-report .p-dropdown {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
}
.export-report .p-dropdown .p-dropdown-label {
  color: transparent !important;
  -webkit-user-select: none;
          user-select: none;
  visibility: hidden !important;
  opacity: 0 !important;
  text-indent: -9999px;
}
.export-report .p-dropdown::before {
  content: "Generate Reports";
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  pointer-events: none;
  color: #495057;
  font-size: 14px;
  font-weight: 500;
  z-index: 4;
  white-space: nowrap;
  display: block;
  visibility: visible;
  opacity: 1;
}
.export-report .p-dropdown.p-disabled::before {
  color: #6c757d;
  opacity: 0.6;
}
.export-report .p-dropdown.p-focus::before {
  color: #007bff;
}
.export-report .p-dropdown:hover::before {
  color: #495057;
}
.export-report .p-dropdown .p-dropdown-trigger {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}
.export-report .p-dropdown .p-dropdown-items-wrapper .p-dropdown-label,
.export-report .p-dropdown .p-dropdown-item .p-dropdown-label {
  display: none !important;
}
@media (prefers-contrast: high) {
  .export-report .p-dropdown::before {
    color: ButtonText;
  }
  .export-report .p-dropdown.p-disabled::before {
    color: GrayText;
  }
}
@media (prefers-reduced-motion: reduce) {
  .export-report .p-dropdown {
    transition: none !important;
  }
}

:host ::ng-deep .export-report .p-dropdown .p-dropdown-label {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

:host ::ng-deep .export-report .p-dropdown .p-dropdown-trigger {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

:host ::ng-deep .export-report .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

:host ::ng-deep .p-checkbox-label {
  margin-left: 0.5rem;
}

.agency-level-preview {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.agency-level-preview img {
  height: 28px;
  width: auto;
  display: inline-block;
}

.agency-level-badge-icon {
  height: 20px;
  width: auto;
  margin-right: 0.5rem;
  vertical-align: middle;
}

.dropzone {
  position: relative;
  height: 200px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.dropzone .textLink {
  color: #1F2937 !important;
}
.dropzone .textLink u {
  text-decoration: underline;
  margin-left: 4px;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fileupload-text {
  display: block;
  width: 85%;
  word-wrap: break-word;
}

.fileupload-meta {
  display: flex;
  flex-direction: column;
}

.fileupload-uploaded-at {
  color: #6b7280;
  font-size: 12px;
  margin-top: 4px;
}

.ph-settings-attempts-row {
  margin-top: 1rem;
}

.template-settings-section {
  margin-top: 0.75rem;
  padding-top: 0;
  border-top: none;
}
.template-settings-section .template-group {
  margin-bottom: 1rem;
}
.template-settings-section .template-group:last-child {
  margin-bottom: 0;
}
.template-settings-section .template-label-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
}
.template-settings-section .template-field-label {
  font-weight: 600;
  font-size: 14px;
  color: #2d388b;
  margin: 0 0 4px 0;
  display: block;
  line-height: 1.3;
}
.template-settings-section .template-label-row .template-field-label {
  margin-bottom: 0;
}
.template-settings-section .template-sms-block .template-field-label {
  margin-top: 0;
  margin-bottom: 4px;
}
.template-settings-section .template-info-icon {
  color: #9ca3af;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
}
.template-settings-section .template-info-icon:hover {
  color: #2d388b;
}
.template-settings-section .template-description {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
  margin: 4px 0 6px 0;
  line-height: 1.35;
}
.template-settings-section .template-description .template-desc-icon {
  color: #9ca3af;
  font-size: 12px;
  margin-top: 1px;
  flex-shrink: 0;
}
.template-settings-section .template-sms-block {
  margin-top: 8px;
}
.template-settings-section .template-field-grid {
  margin-top: 0;
  margin-bottom: 0;
}

:host ::ng-deep .template-settings-section .template-textarea {
  resize: vertical !important;
  min-height: 96px;
  width: 100%;
}
:host ::ng-deep .template-settings-section .template-textarea-sms {
  min-height: 56px;
}

::ng-deep .template-tooltip {
  max-width: 350px;
  white-space: normal;
  word-wrap: break-word;
}

.delivery-action {
  min-width: 7rem;
  justify-content: center;
}

.delivery-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.delivery-value {
  overflow-wrap: anywhere;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
